import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ReelManager from './pages/ReelManager';
import UploadReels from './pages/UploadReels';
import ReelPlayer from './pages/ReelPlayer';
import ConnectAccounts from './pages/ConnectAccounts';
import ManualConnect from './pages/ManualConnect';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import FetchByUrl from './pages/FetchByUrl';
import { AuthProvider, useAuth } from './hooks/useAuth';
import './App.css';

const PrivateRoute = ({ children, role }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/login" replace />;
  return children;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/reels" element={<PrivateRoute><ReelManager /></PrivateRoute>} />
          <Route path="/upload" element={<PrivateRoute><UploadReels /></PrivateRoute>} />
          <Route path="/connect" element={<PrivateRoute><ConnectAccounts /></PrivateRoute>} />
          <Route path="/manual-connect" element={<PrivateRoute><ManualConnect /></PrivateRoute>} />
          <Route path="/player" element={<PrivateRoute><ReelPlayer /></PrivateRoute>} />
          <Route path="/fetch-reel" element={<PrivateRoute><FetchByUrl /></PrivateRoute>} />
          <Route path="/admin" element={<PrivateRoute role="super_admin"><SuperAdminDashboard /></PrivateRoute>} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}